import { booleanAttribute, ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { map, startWith } from 'rxjs';

@Component({
  selector: 'rp-home-coming-soon-label',
  standalone: true,
  templateUrl: './coming-soon-label.component.html',
  styleUrl: './coming-soon-label.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ComingSoonLabelComponent {
  readonly tall = input<boolean, string>(false, {
    transform: booleanAttribute,
  });

  private readonly _translateService = inject(TranslateService);

  // eslint-disable-next-line @typescript-eslint/member-ordering
  readonly lang = toSignal<string>(
    this._translateService.onLangChange.pipe(
      startWith({
        lang: this._translateService.currentLang.toLowerCase(),
      } as LangChangeEvent),
      map(({ lang }: LangChangeEvent) => lang.toLowerCase()),
    ),
  );
}
